import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import everphoneLogoLight from 'Assets/images/logos/everphone_logo_light.svg'

import { GLOBAL_ROUTE_PATHS } from 'Portal/src/router/Router.constants'

import { PublicRequestReturnLabelLanguageSwitcher } from './PublicRequestReturnLabelLanguageSwitcher'

export const PublicRequestReturnLabelHeader = () => (
  <header className="PublicRequestReturnLabelHeader">
    <div className="PublicRequestReturnLabelHeader-inner">
      <div className="PublicRequestReturnLabelHeader-logo">
        <img alt="Everphone Logo" src={everphoneLogoLight} />
      </div>

      <div className="PublicRequestReturnLabelHeader-actions">
        <PublicRequestReturnLabelLanguageSwitcher />

        <Link
          className="PublicRequestReturnLabelHeader-contactLink"
          to={GLOBAL_ROUTE_PATHS.public.contact}
        >
          <FormattedMessage id="PublicRequestReturnLabel_contactUs" />
        </Link>
      </div>
    </div>
  </header>
)
